const getVendorInfo = (state) => {
  return state.vendorInfo;
};

export default {
  getVendorInfo
}